import Vue from 'vue'
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({});

store.registerModule('vux',{
  state:{
    isLoading:false,
    direction: 'forward',
  },
  mutations:{
    updateLoadingStatus(state,payload){
      state.isLoading = payload.isLoading;
    },
    UPDATE_DIRECTION (state, payload) {
      state.direction = payload.direction
    }
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js